import { env } from "@/src/common/constants/env";

interface AppLinks {
	SIGN_IN: string;
	SIGN_UP: string;
}

export const APP_LINKS: AppLinks = {
	SIGN_IN: `${env.APP_URL}/auth`,
	SIGN_UP: `${env.APP_URL}/auth?mode=signup`,
};

export function getSignUpLink(plan: string): string {
	return `${APP_LINKS.SIGN_UP}&plan=${plan}`;
}
